module.exports = "/_next/static/images/rbf-90d75f9b178ea24fe2342c933e944e0a.svg";